module.exports = __webpack_public_path__ + "assets/images/01_1ca699c0307f6a0088c8f40bb86db7d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial/01.png
// module id = 274
// module chunks = 0